/* eslint-disable  */
//@ts-nocheck
'use strict';

import React from 'react';
import _ from 'underscore';
import moment from 'moment-timezone';
import createClass from 'create-react-class';

import ajax from './ajax';
import helpers from './helpers';
import Icons from './Icons';
import {
  Button,
  FormControl,
  InputLabel,
  Modal,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { Close } from '@mui/icons-material';
import { IconButton } from 'react-file-utils';
import { mixTrack } from '@services/mixpanel';
import { debounce } from 'lodash';

const ModalAddToLibrary = createClass({
  getInitialState() {
    return {
      templates: [],
      query: '',
      order: '',
    };
  },
  componentDidMount() {
    this.getLibraryData();
    this.mixTrackDebounced = debounce(mixTrack, 1000);
  },
  getLibraryData() {
    ajax
      .getExerciseTemplates(this.props.influencerId, this.props.target)
      .then((list) => {
        //console.log('[ModalAddToLibrary] Fetched ExerciseTemplate list.', list);      const filterOutYoutubeType = data.filter(e => e.type === 4);
        const filterOutYoutubeType = list.filter((e) => e.type !== 4);
        this.setState({
          templates: filterOutYoutubeType,
        });
      })
      .catch((e) => {
        console.log(
          '[ModalAddToLibrary] Error fetching ExerciseTemplate list.',
          e,
        );
      });
  },
  filterChanged(e) {
    const query = e.target.value.toLowerCase();
    this.setState({
      query: query?.length ? query : null,
    });
    this.mixTrackDebounced({
      type: 'Text Entered in Exercise Title Search',
      payload: {
        'Search Term': query,
      },
    });
  },
  addFromLibrary(id) {
    var template = _.findWhere(this.state.templates, { id });
    //template.disabled = true;
    template.added = true;
    this.setState({
      templates: this.state.templates,
    });
    this.props.addFromLibrary(id);
    mixTrack({
      type: 'Exercise Title Selected From Search',
      payload: {
        'Exercise Type': template.type,
        'Search Term': this.state.query,
        'Selected Exercise Title': '?',
      },
    });
  },
  onSort(ev) {
    console.log('[ModalAddToLibrary] Changed sorting.', ev.target.value);
    this.setState({
      order: ev.target.value,
    });
  },
  render() {
    var items = [];
    var filteredTemplates = this.state.templates;

    if (this.state.order) {
      filteredTemplates = _.sortBy(filteredTemplates, (t) => {
        if (this.state.order === 'update') {
          return -moment(t.updatedAt).unix();
        } else if (this.state.order === 'type') {
          return t.type + t.name;
        } else {
          return t.name;
        }
      });
    }

    if (this.state.query) {
      filteredTemplates = _.filter(filteredTemplates, (t) => {
        return t.name.toLowerCase().indexOf(this.state.query) >= 0;
      });
    }

    _.each(filteredTemplates, (t) => {
      items.push(
        <ModalAddToLibraryItem
          key={t.id}
          id={t.id}
          template={t}
          addFromLibrary={this.addFromLibrary}
          added={t.added}
        />,
      );
    });

    if (items.length === 0) {
      items = <p>No items.</p>;
    }

    return (
      <Modal
        open={this.props.isLibraryOpen ?? false}
        onClose={this.props.closeLibrary}
      >
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full sm:w-1/2 h-2/3 outline-none bg-white  shadow-2xl rounded-xl overflow-y-clip">
          <div className="flex bg-gray-200 p-3 justify-between">
            <Typography variant="h3">Add Exercise</Typography>

            <div className="flex items-center gap-3">
              <FormControl>
                <TextField
                  placeholder="Search by..."
                  value={this.state.query}
                  className="placeholder:text-black"
                  onChange={this.filterChanged}
                />
              </FormControl>
              <FormControl>
                <Select
                  className="min-w-[200px]"
                  value={this.state.order}
                  onChange={this.onSort}
                  displayEmpty
                  // hack for displaying a placeholder with legacy styles
                  renderValue={(selected) => {
                    if (!selected) {
                      return <span className="text-gray-500">Order by...</span>;
                    }

                    switch (selected) {
                      case 'name':
                        return 'Name';
                      case 'update':
                        return 'Last update';
                      case 'type':
                        return 'Exercise type';
                    }
                  }}
                >
                  <MenuItem value="name">Name</MenuItem>
                  <MenuItem value="update">Last update</MenuItem>
                  <MenuItem value="type">Exercise type</MenuItem>
                </Select>
              </FormControl>
              <IconButton onClick={this.props.closeLibrary}>
                <Close />
              </IconButton>
            </div>
          </div>
          <div className="flex flex-col gap-3 px-2 py-5 overflow-y-scroll max-h-[calc(100%-72px)]">
            {items}
          </div>
        </div>
      </Modal>
    );
  },
});

export default ModalAddToLibrary;

const ModalAddToLibraryItem = createClass({
  addFromLibrary(id) {
    this.props.addFromLibrary(id);
  },

  render() {
    var createdOrUpdated = this.props.template.updatedAt
      ? this.props.template.updatedAt
      : this.props.template.createdAt;
    createdOrUpdated = helpers.dateTimeToString(createdOrUpdated);

    let addButton = null;
    if (!this.props.added)
      addButton = (
        <Button
          variant="contained"
          onClick={() => this.addFromLibrary(this.props.template.id)}
        >
          Add to Workout
        </Button>
      );
    else
      addButton = (
        <Button
          variant="outlined"
          color="success"
          onClick={() => this.addFromLibrary(this.props.template.id)}
        >
          Added to Workout
        </Button>
      );

    return (
      <div key={this.props.id} className="legacy">
        {/* glorious magic of flexbox */}
        <div className="flex w-full justify-between px-3 legacy_page_styles">
          <div className="flex items-center gap-3 m-0 p-0 leading-none">
            {Icons.getExerciseIcon(this.props.template.type, false, true)}
            <div className="flex flex-col items-start">
              {/*<strong className={this.props.disabled ? 'disabled' : ''}>*/}
              <Typography variant="h6" className="clear-input">
                {helpers.shortenString(this.props.template.name, 75)}
              </Typography>
              <ul className="flex flex-col items-start">
                {getSummaryItems(this.props.template.summary)}
              </ul>
            </div>
          </div>
          <div className="third">{addButton}</div>
        </div>
      </div>
    );
  },
});

function getSummaryItems(summary) {
  if (!summary) {
    return <li key={0}></li>;
  } else {
    var i = 0;
    return _.map(summary, (s) => {
      let str = helpers.shortenString(s, 75);
      return (
        <li key={i++}>
          <Typography className="text-gray-500" variant="subtitle1">
            {str}
          </Typography>
        </li>
      );
    });
  }
}
